import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while requesting data by a user with an expired token.
 */
export class TokenInvalidError extends RESTError {}
